import { ApiForecast } from 'src/api/queries';
import { dayjs } from 'src/libs/dayjs';

export type ForecastColumn = {
  key: string;
  label: string;
  width: string;
  minW: string;
  render: (forecast: ApiForecast) => React.ReactNode;
  isNameColumn?: boolean;
};

export const FORECAST_COLUMNS: ForecastColumn[] = [
  {
    key: 'name',
    label: 'Forecast name',
    width: '25%',
    minW: '180px',
    render: (f) => f.forecastName,
    isNameColumn: true,
  },
  {
    key: 'scenarios',
    label: 'Scenarios',
    width: '15%',
    minW: '100px',
    render: (f) => f.scenarios.length,
  },
  {
    key: 'periods',
    label: 'Periods',
    width: '15%',
    minW: '100px',
    render: (f) => f.periods,
  },
  {
    key: 'frequency',
    label: 'Frequency',
    width: '15%',
    minW: '100px',
    render: (f) => f.frequency,
  },
  {
    key: 'created',
    label: 'Created',
    width: '15%',
    minW: '120px',
    render: (f) => dayjs(f.created).format('DD.MM.YYYY'),
  },
];
